import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppConfig } from './core/config/app.config';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  title = AppConfig.appName;
}
